import * as React from 'react';
import type { SVGProps } from 'react';
const SvgUser02 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M3.418 18.303C5.391 15.692 8.498 14 12 14c3.501 0 6.609 1.692 8.582 4.303l.027.036c.17.224.351.465.481.697.157.28.274.605.267 1a2.022 2.022 0 0 1-.219.85c-.117.235-.296.491-.546.687-.333.262-.696.355-1.019.393a8.472 8.472 0 0 1-.955.034H5.382c-.337 0-.673 0-.955-.034-.323-.038-.686-.131-1.019-.393a2.023 2.023 0 0 1-.546-.687 2.022 2.022 0 0 1-.219-.85 1.93 1.93 0 0 1 .267-1c.13-.233.312-.473.481-.697l.027-.036ZM6.5 7.5a5.5 5.5 0 1 1 11 0 5.5 5.5 0 0 1-11 0Z"
      clipRule="evenodd"
    />
  </svg>
);
SvgUser02.displayName = 'User02';
export default SvgUser02;
